/**
 * @fileoverview GET handler for the "/integrations/direct/cdi/validation-overrides" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiValidationOverrides } from "./constants";
import type { IntegrationsDirectCdiValidationOverridesResult } from "./types";

export const getIntegrationsDirectCdiValidationOverrides = reactQueryFetcherAdapter(
  integrationsDirectCdiValidationOverrides,
  (signal: AbortSignal): Promise<IntegrationsDirectCdiValidationOverridesResult> => {
    return fetch("/integrations/direct/cdi/validation-overrides", "GET", {}, { signal });
  }
);
